module.exports = BrowserFS.BFSRequire('fs');



//////////////////
// WEBPACK FOOTER
// ./~/browserfs/dist/shims/fs.js
// module id = 27
// module chunks = 0